import React from 'react';
import { Glass } from '../glass/Glass';
import { T } from '../../lib/tokens';

/**
 * View hero card — squircle icon + title + stat pills, styled to match
 * iCloud-style dashboard headers. `stats` is an array of { label, color, bg, border }.
 * `right` slot lets a view drop in actions (e.g. New Goal button).
 */
export const ViewHero = ({ icon: Icon, gradient, title, subtitle, stats = [], right }) => (
  <Glass style={{ padding: '22px 28px', marginBottom: 20 }} hover={false} depth={1}>
    <div style={{ display: 'flex', alignItems: 'center', gap: 22 }}>
      {Icon && (
        <div style={{
          width: 60, height: 60, borderRadius: 16, flexShrink: 0,
          background: gradient || 'linear-gradient(135deg, #f8d77a 0%, #D4921E 100%)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          color: '#fff',
          boxShadow: '0 6px 18px rgba(60,40,90,0.18), inset 0 1px 0 rgba(255,255,255,0.45)',
        }}>
          <Icon size={28} />
        </div>
      )}
      <div style={{ flex: 1, minWidth: 0 }}>
        <h1 style={{ fontSize: 30, fontWeight: 700, color: T.text, letterSpacing: '-0.035em', lineHeight: 1.1, margin: 0 }}>
          {title}
        </h1>
        {subtitle && (
          <div style={{ fontSize: 13, color: T.textMuted, marginTop: 4 }}>{subtitle}</div>
        )}
        {stats.length > 0 && (
          <div style={{ display: 'flex', gap: 8, marginTop: 12, flexWrap: 'wrap' }}>
            {stats.map((s, i) => (
              <span key={i} style={{
                fontSize: 12, fontWeight: 600, padding: '5px 11px', borderRadius: 999,
                background: s.bg || 'rgba(0,0,0,0.04)',
                color: s.color || T.textMuted,
                border: `1px solid ${s.border || 'rgba(0,0,0,0.05)'}`,
              }}>{s.label}</span>
            ))}
          </div>
        )}
      </div>
      {right && <div style={{ flexShrink: 0 }}>{right}</div>}
    </div>
  </Glass>
);
